export default __webpack_public_path__ + "static/media/start chatting.322fc6b7.png";